import store from '../store';

/**
 * Permission Middleware
 * 
 * This middleware provides more specific access control mechanisms
 * beyond the basic route-based role permissions.
 */

export const checkResourcePermission = (resourceType, resourceId) => {
  const role = store.getters._getCurrentRole;
  const userId = store.getters._currentUserId;
  
  if (role === 1) {
    // Admin has full access to all resources
    return true;
  }
  
  if (role === 2) {
    // School Manager can only access resources related to their school
    // This requires implementation based on your data model relationships
    switch (resourceType) {
      case 'library':
        // Check if library belongs to manager's school
        // Example implementation placeholder
        return true;
      case 'student':
        // Check if student belongs to manager's school
        // Example implementation placeholder 
        return true;
      case 'book_loan':
        // Check if loan is from manager's school library
        // Example implementation placeholder
        return true;
      default:
        // For other resources, default to false
        return false;
    }
  }
  
  if (role === 3) {
    // Students can only access their own data and public resources
    switch (resourceType) {
      case 'book_loan':
        // Check if loan belongs to student
        // Example: Compare userId with the loan's number
        return true;
      case 'book':
        // Books are public resources, students can view all
        return true;
      case 'library':
        // Libraries are public resources, students can view all
        return true;
      default:
        // For other resources, default to false
        return false;
    }
  }
  
  // Default deny access
  return false;
};

export const canManageResource = (resourceType) => {
  const role = store.getters._getCurrentRole;
  
  // Admin can manage all resources
  if (role === 1) return true;
  
  // School Manager can manage specific resources
  if (role === 2) {
    return ['library', 'student', 'book', 'book_loan', 'library_book', 'library_setting'].includes(resourceType);
  }
  
  // Students cannot manage resources
  return false;
};

export default {
  checkResourcePermission,
  canManageResource
}; 